const TermHelperNonRequiredField = () => (
	<span className="p-tag p-component p-tag-info" style={{ width: '24px' }}>
		<span className="p-tag-icon fa-duotone fa-info" />
		<span className="p-tag-value" />
	</span>
);

export default TermHelperNonRequiredField;
